/**
 * 'Add a Block' floating picker — block-type groups.
 * Extracted from sectionLayouts.js in iter144 cleanup.
 */

export const BLOCK_GROUPS = [
  {
    label: 'Essentials',
    items: [
      { type: 'custom_text', label: 'Text' },
      { type: 'custom_image', label: 'Image' },
      { type: 'banner', label: 'Button' },
      { type: 'video', label: 'Video' },
      { type: 'form', label: 'Form' },
      { type: 'spacer', label: 'Spacer' },
      { type: 'single_image', label: 'Single Image' },
    ],
  },
  {
    label: 'Sell',
    items: [
      { type: 'products', label: 'Products' },
      { type: 'donations', label: 'Donation' },
      { type: 'booking', label: 'Scheduling' },
      { type: 'product_grid', label: 'Product Grid' },
      { type: 'product_detail', label: 'Product Detail (PDP)' },
      { type: 'cart_table', label: 'Cart Table' },
      { type: 'data_table', label: 'Pricing Table' },
    ],
  },
  {
    label: 'Display',
    items: [
      { type: 'gallery', label: 'Gallery' },
      { type: 'testimonial', label: 'Quote' },
      { type: 'about', label: 'About / Story' },
      { type: 'marquee', label: 'Marquee' },
      { type: 'fluid_canvas', label: 'Fluid Section' },
      { type: 'faq', label: 'FAQ' },
      { type: 'contact', label: 'Contact Section' },
      { type: 'footer', label: 'Footer' },
    ],
  },
  {
    label: 'Links',
    items: [
      { type: 'signup', label: 'Newsletter' },
      { type: 'embed', label: 'Embed' },
    ],
  },
  {
    label: 'Agency',
    items: [
      { type: 'agency_glass_stat',    label: 'Glass Stat Hero' },
      { type: 'agency_service_cards', label: 'Service Cards Row' },
      { type: 'agency_cta_band',      label: 'Emergency CTA Band' },
      { type: 'agency_why_grid',      label: 'Why Us — 6 Grid' },
      { type: 'agency_stat_quad',     label: 'Stat Quad Row' },
      { type: 'agency_review_badge',  label: 'Review Badge' },
    ],
  },
];
